import { Content } from 'src/contexts/ContentContext';
import { SimpleTable } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { formatCurrency } from 'src/utils/numberFormatter';
import { UiMoney } from 'src/WebApiController';

import * as styles from './PaymentDetailsTotals.css';

export type PaymentDetailsTotals = {
  totalPaid: UiMoney;
  outstandingBalance: number;
};

export type PaymentDetailsTotalsTableProps = {
  currencyCode: string;
  totals: PaymentDetailsTotals;
};

export function PaymentDetailsTotalsTable({
  currencyCode,
  totals,
}: PaymentDetailsTotalsTableProps) {
  return (
    <div className={styles.wrapper}>
      <SimpleTable.Table className={styles.table}>
        <SimpleTable.Tbody>
          <SimpleTable.Tr className={styles.row}>
            <SimpleTable.Td>
              <Content id={ContentId.TotalPaid} />
            </SimpleTable.Td>
            <SimpleTable.Td>
              {formatCurrency(
                totals.totalPaid.amt,
                totals.totalPaid.currency ?? currencyCode,
                totals.totalPaid.dec
              )}
            </SimpleTable.Td>
          </SimpleTable.Tr>
          <SimpleTable.Tr className={styles.row}>
            <SimpleTable.Td>
              <Content id={ContentId.OutstandingBalance} />
            </SimpleTable.Td>
            <SimpleTable.Td>
              {formatCurrency(totals.outstandingBalance, currencyCode)}
            </SimpleTable.Td>
          </SimpleTable.Tr>
        </SimpleTable.Tbody>
      </SimpleTable.Table>
    </div>
  );
}
